module.exports = __webpack_public_path__ + "media/assets/images/leanbit_home/soluzioni_personalizzate_img-2a46ad4efddb54bbcbd191b5b59f023e.png";